import React, { Component } from 'react';
import Translator from '../../core/i18n';
import { Log, Level, Logger, Display } from 'ng2-logger';
import { IAppState, IAction } from '../../models/action/core';
import { IUserCalendarProps } from '../../models/components/user-calendar';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import * as Actions from '../../store/actions/userHome';
import { Redirect } from 'react-router';
import { SecurityContextType } from '../../core/SecurityContext';
import Moment from 'moment';
import { UserType } from '../../models/pages/login.d';
import { ActivityTypeEnums } from '../../models/enums/ActivityType';
import Loading from '../loading/loading';
import { Link, withRouter } from 'react-router-dom';
import Content from '../../components/lesson/Activities-Dashboard/containers/content';
import ContentLoader from 'react-content-loader';
import ShowAllButton from '../show-all-button/main';
import moment from 'moment';
const T = Translator.create();
const _logger = Log.create('User Calendar');

interface Course {
    courseId: any;
    activeStatus?: number | null;
    endDate?: Date | null;
    startDate?: Date | null;
    logoUrl?: string | null;
    name?: string | null;
    progress?: number;
    teachers?: string | null;
    classId?: string | null;
    courseEndDate?: Date | null;
    termId?: number | null,
}

class UserHomeCalendar extends React.Component<IUserCalendarProps, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            redirectUrl: '',
            isTeacher: (this.props.userType && (this.props.userType === UserType.Teacher || this.props.userType === UserType.ProgramAdmin)) ? true : false,

        };
        Moment.locale(T.i18next.language);
    }

    public componentDidMount = () => {
        const isTeacher = (this.props.userType && (this.props.userType === UserType.Teacher || this.props.userType === UserType.ProgramAdmin)) ? true : false;
        this.setState({isTeacher: isTeacher});
    }

    // scroll container dynamic height
    public heightCalculate() {
        let userHomeMyCoursesComponent = document.getElementById("getUserHomeMyCourses_Content");
        if(userHomeMyCoursesComponent){
            let componentHeight = userHomeMyCoursesComponent.offsetHeight;
            return componentHeight > 0 ? componentHeight.toString() + 'px' : "400px";
        }else{
            return "400px"
        }
    }

    isWithinDate = (date: any) => {
        let nowDate = moment().format("yyyy-MM-DDTHH:mm:ss");
        let isWithinDateRange = false;
        if (date) {
            isWithinDateRange = date.toString() >= nowDate;
        }
        return isWithinDateRange;
    }

    activeCourses = () => {
        let activeCourses = null;
        if (this.props.userHomeMyCourses && this.props.userHomeMyCourses.length > 0) {
            activeCourses = this.props.userHomeMyCourses.filter((f: any) => {
                const isActive = f.activeStatus === 1;
                let isWithinDateRange = false;
                let dateCondition = false;

                if (f.courseId && this.state.isTeacher) {
                    dateCondition = f.termId === null || f.endDate === null;
                    isWithinDateRange = f.endDate ? this.isWithinDate(f.endDate) : false;
                } else {
                    dateCondition = f.termId === null || f.courseEndDate === null;
                    isWithinDateRange = f.courseEndDate ? this.isWithinDate(f.courseEndDate) : false;
                }

                const isCourseActive = isActive && (dateCondition || isWithinDateRange);
                return isCourseActive;
            });
        }

        return activeCourses;
    };




    public render() {

        if (this.state.redirectUrl.length > 0) {
            return <Redirect push={true} to={window.appSettings.DEFAULT_URL + this.state.redirectUrl} />;
        }
        const startDate = new Date();
        const endDate = new Date();
        startDate.setDate(new Date().getDate());
        endDate.setDate(new Date().getDate() + 15);


        let filteredCourses = this.activeCourses();


        return (
            <>
            {filteredCourses?.length > 0 &&
                <div className="col-md-4 col-12">
                <div className="white-box student-discussions " style={{marginTop:'46px'}}>

                    <div className="d-flex justify-content-between white-box-header">
                        <div>
                            <span className='bodytext1 fw-500' tabIndex={0}>
                                {T.t('r_my_user_teacher_calendar_my_courses_time_line')}
                            </span>
                        </div>
                        {this.props.userHomeCalendarDateArray && this.props.userHomeCalendarActivities && this.props.userHomeCalendarActivities[0] && this.props.userHomeCalendarDateArray !== null ?
                            <div className="align-self-center" tabIndex={0}>
                                <ShowAllButton redirectUrl='/u/activities-dashboard?completed=1'/>
                            </div>
                            : ''}
                    </div>
                    {/* overflowX: (this.props.userHomeMyCourses.length > 0) ? 'auto' : "-moz-hidden-unscrollable", marginBottom: 30, marginTop: 2, height: (this.props.userHomeMyCourses) ? this.heightCalculate() : '300px'  */}
                    <div style={{ padding: '20px 15px',maxHeight:(this.props.userHomeMyCourses) ? `calc(${this.heightCalculate()} - 2em)` : '300px',minHeight:'300px',overflowY: 'auto'}} className="" tabIndex={0}>
                        {<Content isButton={false} take={10} startDate={startDate} endDate={endDate} isScrollDisable={true} />}
                    </div>
                </div>
                </div>
            }
            </>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IUserCalendarProps): IUserCalendarProps => {
    if (!state) {
        return ownProps;
    }

    const newProps: IUserCalendarProps = Object.assign({}, ownProps, {
        userHomeCalendarActivities: state.userHomePage.userHomeCalendarActivities,
        userHomeCalendarIsLoading: state.userHomePage.userHomeCalendarIsLoading,
        userHomeMyCourses: state.userHomePage.userHomeMyCourses,
        userType: state.login.identitiy.userType,
        userHomeCalendarDateArray: state.userHomePage.userHomeCalendarDateArray,
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = (
        next.userHomePage.userHomeCalendarActivities === prev.userHomePage.userHomeCalendarActivities &&
        next.userHomePage.userHomeMyCourses === prev.userHomePage.userHomeMyCourses
        // next.userHomePage.userHomeCalendarIsLoading === prev.userHomePage.userHomeCalendarIsLoading
    );
    return ret;
};
const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return ({
        dispatch
    });
};

const CUserHomeCalendar = connect(
    mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual
    }
)(UserHomeCalendar);

export default withRouter(CUserHomeCalendar);
